import React, { useEffect, useState } from "react";
import { Outlet } from 'react-router-dom';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Sidebar from "./partials/Sidebar";
import Header from "./partials/Header";
import Chat from "./partials/Chat";
import SelectedTask from "../views/selectedTask/selectedTask";

export default function DashboardLayout({ activePage = null, children }) {
    const navigate = useNavigate();
    const userState = useSelector(state => state.auth);

	const pageNavigate = (pageName) => {
			navigate(pageName);
	};
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [addClass, setAddClass] = useState(false);
	const [show, setShow] = useState(false);

  // Add a class to the element when scrolled 50px
	const handleScroll = () => {
		if (window.scrollY >= 50) {
			setAddClass(true);
		} else {
			setAddClass(false);
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);

		// Cleanup the event listener when the component unmounts
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	const dispatch = useDispatch();


	const handleClick = () => {
		if(userState.isAuthenticated){
			setShow(true)
		}else{
			setShow(false)
			navigate('/login')
		}
	}

	const toggleHandler = tgl => {
		setShow(!tgl)
	}


	return (
		<div className="layout">
            <div className="layout_container">
                <Sidebar toggleHandler={toggleHandler} />

                <div className={`layout_wrapper ${show ? 'layout_toggle' : ''}`}>

                    <div className="layout_content">
                        { children }
                    </div>
					
                </div>
				<Chat  />
            </div>
		</div>
	);
}
